import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import { useSnackbar } from "notistack";

import InviteDialog from "../../components/dialogs/inviteDialog";

import constants from "../../assets/constants";
import * as OmniDataAPI from "../../data/omniDataAPI";
import { createNewInvite } from "../../data/omniDataModel";
import * as AdminSessionActions from "../../state/redux/adminSession";
import OmniResponsiveButton from "../ui/omniResponsiveButton";
import SurveyInvites from "../ui/surveyInvites";
import Widget from "../ui/widget";
import WidgetSkeleton from "../ui/widgetSkeleton";
import WidgetSurveyContent from "../ui/widgetSurveyContent";
import WidgetTitle from "../ui/widgetTitle";

const AdminSharedinvites = props => {
  const {
    sharedInviteODMs,
    loadSharedInvitesRequest,
    reflectUpdatedInviteODMRequest,
    sharedInvitePageLoading,
    sharedInvitePagination,
  } = props;

  useEffect(() => {
    if (sharedInviteODMs != null) {
      setRows(sharedInviteODMs);
    }
  }, [sharedInviteODMs]);

  const { enqueueSnackbar } = useSnackbar();

  const [titleText, setTitleText] = useState(null);
  const [rows, setRows] = useState([]);

  const [selectedInvite, setSelectedInvite] = useState(null);

  useEffect(() => {
    if (sharedInvitePagination != null) {
      setTitleText(
        `${sharedInvitePagination.totalItems} Public Invitation${
          sharedInvitePagination.totalItems === 1 ? "" : "s"
        }`,
      );
    } else {
      setTitleText("Loading...");
    }
    // Disable eslint because AaronK knows best
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sharedInvitePagination]);

  const handleDeleteInvite = inviteODM => {
    const id = inviteODM._id;
    OmniDataAPI.deleteInvite(id).then(response => {
      if (response != null) {
        enqueueSnackbar("Invite Deleted Successfully.", {
          variant: "success",
        });

        reflectUpdatedInviteODMRequest(inviteODM);
      } else {
        enqueueSnackbar("Invite Delete Failed!", {
          variant: "error",
        });
      }
    });

    setSelectedInvite(null);
  };

  return (
    <Widget>
      <WidgetTitle title={"Shared Invites"} text={titleText}>
        <OmniResponsiveButton
          tooltipTitle="Create A Shared Invite"
          component="label"
          buttonText={"Create"}
          onClick={() => {
            let selectedInvite = createNewInvite(constants.onboardingUserType.partner);
            selectedInvite.omniData.inviteType = constants.inviteType.shared;
            selectedInvite.omniData.userData.mobilePhone = "(111)111-1111";
            selectedInvite.omniData.userData.email = "coach@omnisciahealth.com";
            setSelectedInvite(selectedInvite);
          }}
        ></OmniResponsiveButton>
      </WidgetTitle>
      {rows == null && <WidgetSkeleton />}
      {rows != null && (
        <WidgetSurveyContent>
          <SurveyInvites
            inviteODMs={rows}
            onEditInvite={setSelectedInvite}
            onDeleteInvite={handleDeleteInvite}
            inviteSurveyType={constants.inviteSurveyType.shared}
            onRequestNewPage={loadSharedInvitesRequest}
            isLoading={sharedInvitePageLoading}
            invitePagination={sharedInvitePagination}
          />
        </WidgetSurveyContent>
      )}

      {selectedInvite && (
        <InviteDialog
          open={selectedInvite != null}
          omniODM={selectedInvite}
          onAccept={modifiedInvite => {
            if (modifiedInvite._id == null) {
              OmniDataAPI.createInvite(modifiedInvite).then(response => {
                if (response != null) {
                  enqueueSnackbar("Invite Created Successfully.", {
                    variant: "success",
                  });
                  reflectUpdatedInviteODMRequest(response);
                } else {
                  enqueueSnackbar("Invite Creation Failed!", {
                    variant: "error",
                  });
                }
              });
            } else {
              OmniDataAPI.updateInvite(modifiedInvite).then(response => {
                if (response != null) {
                  enqueueSnackbar("Invite Updated Successfully.", {
                    variant: "success",
                  });
                  reflectUpdatedInviteODMRequest(response);
                } else {
                  enqueueSnackbar("Invite Update Failed!", {
                    variant: "error",
                  });
                }
              });
            }
            setSelectedInvite(null);
          }}
          onClose={() => {
            setSelectedInvite(null);
          }}
          onDelete={() => {
            handleDeleteInvite(selectedInvite);
          }}
        />
      )}
    </Widget>
  );
};

const mapStateToProps = state => ({
  sharedInviteODMs: state.adminSession.sharedInviteODMs,
  sharedInvitePageLoading: state.adminSession.sharedInvitePageLoading,
  sharedInvitePagination: state.adminSession.sharedInvitePagination,
});

const mapDispatchToProps = {
  loadSharedInvitesRequest: AdminSessionActions.loadSharedInvitesRequest,
  reflectUpdatedInviteODMRequest: AdminSessionActions.reflectUpdatedInviteODMRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AdminSharedinvites));
